import {useMemo} from "react";
import {stateColors} from "../StateColors";
import {type ShapeProps} from "../../controller/ShapeController";
import {Billboard, Line} from "@react-three/drei";
import {lineWidth, useShapeEffects} from "./ShapeEffects.ts";

export function InteractiveSphere({position, diameter, minZ, state, controller, touchingObject}: ShapeProps) {

    const meshRef = controller.getMeshRef();
    const color = stateColors[state];

    const {edgeColor, emissiveIntensity, metalness, roughness, opacity} =
        useShapeEffects(controller, touchingObject, color, position.z, minZ);

    // sphere geometry basics
    const radius = diameter / 2;
    const segments = 64;

    // circle for line
    const circlePoints = useMemo(() => {
        const innerRadius = radius * 1.005;
        const points: [number, number, number][] = [];
        for (let i = 0; i <= segments; i++) {
             const angle = (i / segments) * Math.PI * 2;
             points.push([
                  Math.cos(angle) * innerRadius,
                  Math.sin(angle) * innerRadius,
                 0
             ]);
        }
        return points;
    }, [position, meshRef]);


    return ( <>
        <mesh
            ref={meshRef} position={[position.x, position.y, position.z]}
            {...controller.getPointerHandlers()}
        >
            <sphereGeometry args={[radius, 32, 32]}/>
            <meshStandardMaterial
                color={stateColors[state]}
                transparent
                opacity={opacity}
                emissive={stateColors[state]}
                emissiveIntensity={emissiveIntensity}
                roughness={roughness}
                metalness={metalness}
            />
        </mesh>
        <Billboard position={[position.x, position.y, position.z]}>
            <Line
                points={circlePoints}
                color={edgeColor ?? color}
                lineWidth={lineWidth}
            />
        </Billboard>
        </>
);
}
